<template>
  <div class="result">
    <div class="rightmouse" :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="reviewheader"
    :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">
      <div class="left">
        <p>本次图片筛选任务已结束 ，备选图共<span style="font-size:18px;font-weight:bold;margin:0 6px;">{{picTotal}}</span>张,最终入选<span style="margin:0 6px;color:#FF8C06;font-size:18px;font-weight:bolder;">{{totalCheck}}</span>张！ 您可以进行下载操作</p>

      </div>
      <div v-if="powersObj.outputPictureArticleFilter"
           class="right">
        <button :style="{backgroundColor:packageText=='压缩包'?'rgba(66,202,96,1)':'#909399',pointerEvents: packageText=='压缩包'?'all':'none'}"
                @click="downloadPackage">
          <img src="@/assets/sreenpic/download.png"
               alt="">
          {{packageText}}
        </button>
        <button :style="{backgroundColor:pdfText=='PDF合集'?isSimple? '#185ed3' : 'rgba(255,141,5,1)':'#909399',pointerEvents: pdfText=='PDF合集'?'all':'none'}"
                @click="downloadPdf">
          <img src="@/assets/sreenpic/download.png"
               alt="">
          {{pdfText}}
        </button>
      </div>
    </div>

    <div @scroll="resultScroll($event)"
         class="reviewnr">
      <section ref="result">
        <div @click="openDialog(index,item)"
             class="img-wrapper"
             v-for="(item, index) in checkList"
             :key="index">
          <img class="img"
               @contextmenu.prevent="rightShow($event)"
               ondragstart="return false;"
               :src="item.src" />

          <!-- <div class="choosethis">
            <img src="@/assets/sreenpic/close.png" alt />
          </div> -->

          <el-tooltip class="item"
                      effect="dark"
                      content="查看备注"
                      placement="top">
            <div @click.stop="openAllDesc(item)"
                 class="choosedesc">
              <img src="@/assets/sreenpic/msg.png"
                   alt />
            </div>
          </el-tooltip>

          <!-- <div @click.stop="opendesc" class="writedesc">
            <img src="@/assets/sreenpic/desc.png" alt />
          </div> -->
        </div>
      </section>
      <img v-if="showLoading"
           width="200px"
           style="margin-left: 43%;"
           src="@/assets/blue-preloader.gif"
           alt />
    </div>

    <picdescdialog :messageList="messageList"
                   @handleClose="handleClose"
                   :dialogVisible="descdialogVisible"></picdescdialog>

    <picview v-if="picdialogVisible"
             :dialogVisible="picdialogVisible"
             @handleClose="handleClosepic"
             :passChoose='passChoose'
             :picList='picList'></picview>
  </div>
</template>

<script>
import { picdescdialog } from "@/components/index";
import picview from '@/components/picView/picView'
import { getDate, formatConversion } from "@/plugins/getdate";
import {
  listCheck,
  listMessage,
  getTask
} from "@/api/workflow";

import {
  getPictures
} from "@/api/picture";
import { powersObj } from "@/constants/powers";
import { picPrefix } from "@/constants/piccommon";
export default {
  components: {
    picdescdialog, picview
  },
  data () {
    return {
      passFlag: true,
      showLoading: false,
      //权限
      powersObj,
      //备注列表
      messageList: [],

      picTotal: 0,
      picdialogVisible: false,
      passChoose: {},
      picList: [],
      descdialogVisible: false,
      totalCheck: 0,
      currentPageCheck: 1,
      pageSizeCheck: 20,
      checkList: [],

      packageText: '压缩包',
      pdfText: 'PDF合集',
      packageUrl: '',
      pdfUrl: '',

      //鼠标右击
      rightMouseTop:0,
      rightMouseLeft:0,
      rightMouseFlag:false,
    };
  },
  methods: {

    //图片右击
    rightShow(e){
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },

    //下载压缩包
    downloadPackage () {
      let a = document.createElement("a");
      a.href = picPrefix + this.packageUrl;
      document.body.appendChild(a);
      a.click();
    },

    //下载pdf
    downloadPdf () {
      let a = document.createElement("a");
      a.href = picPrefix + this.pdfUrl;
      window.open(a.href, '_blank');
      // document.body.appendChild(a);
      // a.click();
    },
    //结果图片滚动事件
    resultScroll (e) {
      // console.log(this.$refs.selected.offsetHeight)
      // console.log(e.srcElement.scrollTop, e.target.scrollTop)
      if (e.srcElement.scrollTop + 667 >= this.$refs.result.offsetHeight) {
        if (this.checkList.length !== this.totalCheck && this.passFlag) {
          this.currentPageCheck++;
          let dataActList = { page: (this.currentPageCheck - 1), pageSize: this.pageSizeCheck, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
          this.showLoading = true
          this.passFlag = false
          this.listCheckAsync(dataActList)
        }
      }
    },

    //图片描述
    openAllDesc (e) {
      this.descdialogVisible = true
      let data = {
        pictureArticleFilterTaskId: e.pictureArticleFilterTaskId,
        pictureId: e.pictureId
      }
      this.listMessageAsync(data)
    },
    //打开图片浏览
    openDialog (i, e) {
      this.descdialog = false
      this.passChoose = e
      this.passChoose.myId = i
      for (let z = 0; z < this.checkList.length; z++) {
        this.checkList[z].myId = z
      }

      this.picList = this.checkList
      this.picdialogVisible = true
    },
    //关闭图片浏览
    handleClosepic () {
      this.picdialogVisible = false
    },
    opendesc () {

    },
    handleClose () {
      this.descdialogVisible = false
    },
    //查看所有备注
    async listMessageAsync (val) {
      let { status, data, message, errors } = await listMessage(val);
      if (status) {
        this.messageList = []

        for (let i = 0; i < data.length; i++) {
          data[i].createAtMy = formatConversion(data[i].createAt.toString())
          data[i].createUserName = data[i].createUserInfo.name
        }
        this.messageList = data
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取选入图片列表
    async getTaskAsync (val) {
      let { status, data, message, pagination } = await getTask(val);
      if (status) {
        if (data.hasOwnProperty('resultPdf')) {
          if (data.resultPdf) {
            this.pdfText = 'PDF合集'
            this.pdfUrl = data.resultPdf
          } else {
            this.pdfText = 'PDF生成中'
          }
        } else {
          this.pdfText = 'PDF生成中'
        }
        if (data.hasOwnProperty('resultPackage')) {
          if (data.resultPackage) {
            this.packageText = '压缩包'
            this.packageUrl = data.resultPackage
          } else {
            this.packageText = '压缩包生成中'
          }
        } else {
          this.packageText = '压缩包生成中'
        }
        this.picTotal = data.picutreCount
      }
    },

    //获取选入图片列表
    async listCheckAsync (val) {
      let { status, data, message, pagination } = await listCheck(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if(data[i].indexpicInfo){
            if(!data[i].indexpicInfo.picThumbW240H160){
              data[i].src = require('@/assets/house/onloadpicin.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicin.png')
            }else{
              data[i].src = picPrefix + data[i].indexpicInfo.picThumbW240H160
              data[i].picThumbW1080 = picPrefix + data[i].indexpicInfo.picThumbW1080
            }

            if (data[i].indexpicInfo.picThumbW240H160 === 'error') {
              data[i].src = require('@/assets/house/onloadpicerror.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
            }

            let imgTest = new Image()
            imgTest.src = picPrefix + data[i].indexpicInfo.picThumbW240H160
            imgTest.onerror = () => {
              data[i].src = require('@/assets/house/onloadpicerror.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
            }
          }else{
            data[i].src = require('@/assets/house/onloadpicin.png')
            data[i].picThumbW1080 = require('@/assets/house/onloadpicin.png')
          }
          // console.log(data[i].indexpicInfo.createAt)
          data[i].createAtMy = formatConversion(data[i].indexpicInfo.createAt.toString())
        }

        this.totalCheck = pagination.total
        // this.checkList = data
        if (this.currentPageAct == 1) {
          this.checkList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.checkList.push(data[i])

          }
          // Array.prototype.push.apply(this.checkList,data)
        }
      }
      this.showLoading = false
      this.passFlag = true
    },
  },
  created () {
    let dataChooseList = { page: (this.currentPageCheck - 1), pageSize: this.pageSizeCheck, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
    this.listCheckAsync(dataChooseList)

    this.getTaskAsync(this.$route.query.pictureArticleFilterTaskId)
  },
  beforeDestroy () {

  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./result.scss";
</style>
